export default defineNuxtPlugin((nuxtApp) => {

     
    const apiStips = $fetch.create({
      baseURL: 'https://www.stips.minpolj.gov.rs/stips/ajax',
       
    })
  
    // Expose to useNuxtApp().$api
    return {
      provide: {
        apiStips
      }
    }
  })
  
